import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import { SubscriptionTier } from '@@/package/mapper/subscription/model/SubscriptionTierType';
import { SubscriptionStatus } from '@@/package/mapper/subscription/model/SubscriptionStatusType';
import { BillingCycle } from '@@/package/mapper/subscription/model/BillingCycleType';

export { SubscriptionTier, SubscriptionStatus, BillingCycle };

export class SubscriptionModel extends Model {
    constructor(
        public id: number = 0,
        public organizationId: number = 0,
        public planId: number = 0,
        public planTier: SubscriptionTier = SubscriptionTier.BASIC,
        public planName: string = '',
        public billingCycle: BillingCycle = BillingCycle.MONTHLY,
        public pendingBillingCycle: BillingCycle | null = null,
        public status: SubscriptionStatus = SubscriptionStatus.INACTIVE,
        public startDate: string = '',
        public endDate: string = '',
        public cancelRequestedAt: string | null = null,
        public cardBrand: string | null = null,
        public cardLast4: string | null = null,
        public expectedAmount: number | null = null,
        public retryCount: number = 0,
        public nextBillingDate: string | null = null,
        public suspensionDate: string | null = null,
        public currency: string = 'KRW',
        public upgradablePlanTier: SubscriptionTier | null = null,
        public paymentId: number | null = null,
        public amountCharged: number | null = null,
        public timeZoneId: string = '',
    ) {
        super();
    }

    public static create(model: Partial<SubscriptionModel>): SubscriptionModel {
        return createModel<SubscriptionModel>(SubscriptionModel, {...model});
    }
}
